import React, {useState} from "react";

import "./AdministrationPage.css";

import {Col, Tab, Tabs} from "react-bootstrap";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import { useModels } from "../../helpers/models";
import DictionariesManagementComponent from "../../components/dictionary/DictionariesManagementComponent";
import {dictionaries} from "./DictionariesComponentConfig";
import GlobalConfigComponent from "../../components/globalConfig/GlobalConfigComponent";
import AuditComponent from "../../components/audit/AuditComponent";
import auditConfig from "./auditConfig";
import GroupPermissionsComponent from "../../components/permissions/GroupPermisionsComponent";
import {hasAdminPanelFullAccess} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

const AdministrationPage = (props) => {

    const [loader, setLoader] = useState(true);
    const { t } = useTranslation();
    const models = useModels();

    return (
        <>

            <Loader loader={loader}/>
            <CustomContainer title={t("menu.admin_panel")}

                             parent={
                                 <LinkIconButton
                                     model={models.admin}
                                 />
                             }
            >
                <Col>
                    <div>
                        <Tabs
                            mountOnEnter
                            unmountOnExit
                            id="adminActions">

                            <Tab eventKey="main" title={t("common.dictionaries")}>
                                <DictionariesManagementComponent
                                    setLoader={setLoader}
                                    dictionaries={dictionaries(t)}
                                />
                            </Tab>
                            <Tab eventKey="config" title={t("common.configuration")}>
                                <GlobalConfigComponent
                                    setLoader={setLoader}
                                />
                            </Tab>
                            {hasAdminPanelFullAccess() &&
                                <Tab eventKey="permissions" title={t("permissions.user_groups")}>
                                    <GroupPermissionsComponent/>
                                </Tab>
                            }
                            <Tab eventKey="audit" title={t("common.tracking")}>
                                <AuditComponent auditConfig={auditConfig(t)} setLoader={setLoader}/>
                            </Tab>

                        </Tabs>
                    </div>
                </Col>


            </CustomContainer>


        </>
    );
};


export default AdministrationPage;
